/**
 * Section label for tabs / palette grouping.
 * Empty or whitespace section_name means no subsection — use subject only.
 */
export const getExamSectionKey = (q) => {
  if (!q) return "";
  const subject = String(q.subject ?? "").trim();
  const section = String(q.section_name ?? "").trim();
  if (!section) return subject;
  return `${subject} ${section}`.trim();
};
